import { render, staticRenderFns } from "./QualifiedApplicant.vue?vue&type=template&id=35bf24a0&scoped=true&"
import script from "./QualifiedApplicant.vue?vue&type=script&lang=js&"
export * from "./QualifiedApplicant.vue?vue&type=script&lang=js&"
import style0 from "./QualifiedApplicant.vue?vue&type=style&index=0&id=35bf24a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf24a0",
  null
  
)

export default component.exports